import { BrowserRouter, Route, Routes } from "react-router-dom"
import HomePage from "./pages/HomePage";
import AboutUsPage from "./pages/AboutUsPage";
import BookTablePage from "./pages/BookTablePage";
import ContentPage from "./pages/ContentPage";
import MenuPage from "./pages/MenuPage";
import React from "react";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <React.Fragment>
      <BrowserRouter basename="/yummy-restaurant-website" >
        <Routes >
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/book-table" element={<BookTablePage />} />
          <Route path="/menu" element={<MenuPage />} />
          <Route path="/content" element={<ContentPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>

    </React.Fragment>
  )
}

export default App;
